import type { ButtonProps } from '@/components/ui'
import { isSingleProjectPlan, useAccount, useCheckout } from '@/modules/account'
import { useProject } from '@/modules/projects'

interface ProcessButtonProps extends ButtonProps {
  isBlocked?: boolean
  validationBehaviour: 'message' | 'hidden' | 'disable-only'
}

export const SingleProjectMessage = ({
  isBlocked,
  validationBehaviour,
}: ProcessButtonProps) => {
  const account = useAccount()
  const project = useProject()
  const { renewProject } = useCheckout()

  if (!isBlocked) return
  if (validationBehaviour !== 'message') return
  if (!isSingleProjectPlan(account?.planKind)) return
  if (!project?.expired) return

  return (
    <span className="text-muted-foreground flex items-center gap-1 text-xs">
      Project expired.
      <button
        className="text-brand underline cursor-pointer"
        onClick={() => renewProject(project.slug)}
        type="button"
      >
        Renew project
      </button>
    </span>
  )
}
